import React from 'react';
import '@material/web/textfield/outlined-text-field.js';

/**
 * Textarea
 * Props: label, rows, value, onChange, placeholder, error, disabled
 */
const Textarea = ({
  label,
  error,
  className = '',
  rows = 3,
  value,
  onChange,
  disabled,
  placeholder,
  ...rest
}) => {
  const handleInput = (e) => {
    if (onChange) {
      onChange({
        target: {
          value: e.target.value,
          name: e.target.name || rest.name,
        }
      });
    }
  };

  return (
    <div className={`form-group ${className}`} style={{ marginBottom: 'var(--sp-4)' }}>
      <md-outlined-text-field
        type="textarea"
        label={label}
        rows={rows}
        value={value ?? ''}
        placeholder={placeholder || undefined}
        disabled={disabled || undefined}
        error={!!error || undefined}
        supporting-text={error || ''}
        onInput={handleInput}
        style={{ width: '100%', resize: 'vertical' }}
        {...rest}
      />
    </div>
  );
};

export default Textarea;
